// import axios from "axios";
// import { SERVICE_URL, STATUS_CODE } from "./constant";
// export const CALL_API = async (method, action, payload) => {
//   try {
//     const resp = await axios({
//       method,
//       url: `${SERVICE_URL}${action}`,
//       data: payload,
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         // token: window.localStorage.getItem("token"),
//       },
//     });
//     // const { status, response } = resp.data;
//     return resp.data;
//   } catch (err) {
//     return err;
//   }
// };

import axios from "axios";
import { SERVICE_URL } from "./constant";

export const CALL_API = async (method, action, payload) => {
  try {
    const resp = await axios({
      method,
      url: `${SERVICE_URL}${action}`,
      data: payload,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: window?.localStorage?.getItem("token") || "",
      },
    });
    if (resp?.data?.ResponseCode === 401) {
      window.localStorage.removeItem("token");
      window.location.href = "https://www.uat.trackright.ai/";
    }
    return resp.data;
  } catch (err) {
    console.error("API call error:", err);

    if (err?.response?.data?.ResponseCode === 401) {
      window.localStorage.removeItem("token");
      window.location.href = "https://www.uat.trackright.ai/";
    }
    // If response exists (like 400 or 500), return its .data structure
    if (err.response && err.response.data) {
      return err.response.data;
    }

    // Otherwise, return a generic fallback
    return {
      ResponseCode: 500,
      message: "Something went wrong",
      data: { message: err.message || "Unknown error" },
    };
  }
};

// import axios from "axios";

// export const api = axios.create({
//   baseURL: "http://127.0.0.1:3000/",
//   headers: {
//     "Content-Type": "application/json",
//     // Include any necessary authorization headers
//     // "Authorization": "Bearer your-token-here"
//   }
// });

// export const CALL_API = async (method, action, payload) => {
//   try {
//     const resp = await api({
//       method,
//       url: action,
//       data: payload,
//     });
//     const { status, data } = resp;
//     if (status === 200 || status === true) return data;
//     else throw new Error("Request failed");
//   } catch (err) {
//     console.error("API call error:", err);
//     console.error("Action:", action);
//     return err;
//   }
// };
